export default {
  svgPath: `
    <path d="M18.5 10H2.5M18.5 10L12 16.5M18.5 10L12 3.5" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
  `,
  title: 'Arrow Right',
  viewBox: '0 0 21 20',
};
